import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import { Link, Redirect } from 'react-router-dom'
import SignupFields from 'forms/auth/register/fields'
import BodyClass from 'components/shared/body-class';
import Button from 'forms/shared/buttons';
import placesActions from 'actions/places/actions'
import authActions from 'actions/auth/actions'
import validate from './validator'

const form = 'register-form'

const Register = ({ csrfToken, formPath, isAuth, isMerchant, places, fetchPlaceOptions, updateFormpath }) => {
  useEffect(() => {
    updateFormpath({ formPath: '/register' })
    fetchPlaceOptions({ published: true })
  }, [])

  const handleSubmit = (event) => {
    event.currentTarget.phone.value = event.currentTarget.phone_number.value
    return true
  }

  return (
    <div className="flex flex-col min-h-screen justify-between">
      <BodyClass className="bg-secondary-lightgray" />
      <div className="w-full flex flex-col my-auto lg:my-10 justify-center items-center pt-10 pb-10 pr-4 pl-4">
        {isAuth && <Redirect to={isMerchant ? '/merchant' : '/client'} push strict={true} />}
        <div className="bg-white w-full p-3 sm:p-5 lg:w-4/12 md:w-6/12 sm:w-10/12 shadow-loginbox rounded-sm">
          <div className="flex justify-between items-start xs:items-center mb-5 xs:flex-row flex-col">
            <h2 className="text-lg font-normal text-gray-700">Sign up</h2>
            <h4 className="text-sm text-primary-lightgray">
              Already registered?
              <Link to={`/login`} className="text-black ml-1">
                Login here
              </Link>
            </h4>
          </div>
          <div className="flex justify-between items-center mb-5 relative flex-col xs:flex-row">
            <a href="/auth/google" className="text-white p-2 bg-secondary-google rounded-sm w-full xs:w-7/8 text-center"><i className="fa fa-google mr-3"></i> Sign up with Google</a>
          </div>
          <div className="flex justify-center items-center mb-5 relative">
            <div className="border-b border-gray-500 w-full absolute"></div>
          </div>
          <form method="POST" action={formPath} onSubmit={handleSubmit}>
            <input type="hidden" name="_csrf" defaultValue={csrfToken} />
            <SignupFields form={form} placesOptions={places} />
            <Button
              buttonClassname="btn btn-primary font-normal"
              containerClassname={'text-left'}
            >
              SIGN UP
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

Register.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isMerchant: PropTypes.bool,
  formPath: PropTypes.string,
  csrfToken: PropTypes.string,
  isAuth: PropTypes.bool,
  places: PropTypes.array,
  fetchPlaceOptions: PropTypes.func.isRequired,
  updateFormpath: PropTypes.func
}

const mapStateToProps = ({ auth, places }) => ({
  isAuth: auth.authenticated,
  isMerchant: auth.authenticated && auth.user.roles.includes('merchant'),
  formPath: auth.formPath,
  csrfToken: auth.csrfToken,
  places: places.options,
})

const mapDispatchToProps = {
  fetchPlaceOptions: placesActions.fetchPlaceOptions,
  updateFormpath: authActions.updateFormpath
}

export const WrappedRegister = reduxForm({
  form,
  validate
})(Register)

export default connect(mapStateToProps, mapDispatchToProps)(WrappedRegister)
